import * as React from "react";
import * as ReactDOM from "react-dom";

interface Props
{
    type?: string;
    children: any;
}

import './HighlightText.scss';

export default class HighlightText extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {type, children} = this.props;

        return <h3 styleName={type}>

            {children}

        </h3>
    }
}


// WEBPACK FOOTER //
// ./src/ts/app/common/highlight-text/HighlightText.tsx